import { gsap } from 'gsap';
import { Container, Sprite } from '../../odie';
import { app } from '../app';
import { IAnimation } from '../../lib/pattern/IAnimation';
import { ParticleEmitter } from '../particles/ParticleEmitter';
import { getMatch2AssetPath } from '../util/assets';

export class TunaFishBreakAnimation extends Container implements IAnimation {
  public async start() {
    // create blast
    const blast = this.createBlast();

    // create debris emitter
    const debrisEmitter = this.createEmitter();

    // animate debris and blast
    await Promise.all([
      this.animateDebris(debrisEmitter),
      this.animateBlast(blast),
    ]);
  }

  public stop() {}

  private async animateDebris(debris: ParticleEmitter) {
    // spawn debris
    this.addChild(debris.view);

    // start
    await debris.start();

    // despawn blast
    this.removeChild(debris.view);
  }

  private async animateBlast(blast: Sprite) {
    // set initial values
    blast.scaleX = 0.2;
    blast.scaleY = 0.2;

    // spawn blast
    this.addChild(blast);

    // animate
    await gsap.to(blast, {
      scaleX: 2,
      scaleY: 2,
      duration: 0.2,
      ease: 'power1.out',
    });

    // despawn blast
    this.removeChild(blast);
  }

  private createEmitter(): ParticleEmitter {
    return app.particles.create({
      textures: [getMatch2AssetPath('blocks/tuna/8.png')],
      rate: 0,
      limit: 10,
      emitterDuration: 0,
      duration: 0.5,
      velocity: { x: 0, y: 0 },
      scale: [
        { x: 0.5, y: 0.5 },
        { x: 0.7, y: 0.7 },
      ],
      behaviors: [
        { type: 'explode', magnitude: [100, 300] },
        // { type: 'gravity', gravity: { x: 0, y: 700 } },
        { type: 'scale', to: 0 },
        { type: 'kinematic' },
      ],
    });
  }

  private createBlast(): Sprite {
    const blast = Sprite.from('fx.block/fx.block.explode.png');
    blast.anchorX = 0.5;
    blast.anchorY = 0.5;
    return blast;
  }
}
